import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Textarea from 'react-textarea-autosize';
import { isValid, format, addYears } from 'date-fns';
import { TODAY } from 'constants/constants';
import DatePicker from 'components/Shared/DatePicker';
import styles from '../WorkExperience.module.scss';
import { Button } from 'react-bootstrap';

const WorkExperienceForm = ({
  index,
  updateWorkExperience,
  currentWorkExperience,
  isLast,
  addNewWorkExperience,
}) => {
  const [newWorkExperience, setNewWorkExperience] = useState(
    currentWorkExperience
  );
  const [jobTitle, setJobTitle] = useState(
    currentWorkExperience?.job_title || ''
  );
  const [companyName, setCompanyName] = useState(
    currentWorkExperience?.company_name || ''
  );
  const [startDate, setStartDate] = useState(
    currentWorkExperience?.start_date
      ? new Date(currentWorkExperience.start_date)
      : new Date()
  );
  const [endDate, setEndDate] = useState(
    currentWorkExperience?.end_date
      ? new Date(currentWorkExperience.end_date)
      : ''
  );
  const [description, setDescription] = useState(
    currentWorkExperience?.description || ''
  );
  const [noTitle, setNoTitle] = useState(false);
  const [noWorkplace, setNoWorkplace] = useState(false);

  useEffect(() => {
    if (checkChanges()) {
      // Error handling
      setNoTitle(!jobTitle);
      setNoWorkplace(!companyName);

      if (!jobTitle || !companyName) {
        return;
      }

      let updates = {
        ...newWorkExperience,
        job_title: jobTitle,
        company_name: companyName,
        description: description,
        start_date: formatDate(startDate),
        end_date: endDate ? formatDate(endDate) : '',
      };

      // Save user input
      setNewWorkExperience(updates);

      if (updates !== currentWorkExperience) {
        updateWorkExperience(updates, index);
      }
    }
  }, [jobTitle, companyName, startDate, endDate, description]);

  const checkChanges = () => {
    if (
      jobTitle !== newWorkExperience.job_title ||
      companyName !== newWorkExperience.company_name ||
      formatDate(startDate) !== newWorkExperience.start_date ||
      (endDate && formatDate(endDate) !== newWorkExperience.end_date) ||
      (!endDate && newWorkExperience.end_date !== '') ||
      description !== newWorkExperience.description
    ) {
      return true;
    }
    return false;
  };

  const formatDate = (date) => format(date, 'yyyy-MM-dd HH:mm:ss');

  return (
    <div style={isLast ? { display: 'flex', flexDirection: 'column' } : null}>
      <div className="mb lato-bold mt">Job Title:</div>
      <input
        className="form-control"
        onChange={(event) => setJobTitle(event.target.value)}
        name="job_title"
        placeholder="Eg: Software Engineer"
        type="text"
        value={jobTitle}
      />
      {noTitle && (
        <div className={`mb ${styles.warning}`}>
          You must provide a job title.
        </div>
      )}
      <div className="mb lato-bold mt">Company/Organization:</div>
      <input
        className="form-control"
        onChange={(event) => setCompanyName(event.target.value)}
        name="company_name"
        placeholder="Eg: Google"
        type="text"
        value={companyName}
      />

      {noWorkplace && (
        <div className={`mb ${styles.warning}`}>
          You must provide a company or organization name.
        </div>
      )}
      <div className="mb lato-bold mt">Start date:</div>
      <DatePicker
        className="form-control"
        isClearable={false}
        dateFormat="do MMMM yyyy"
        showYearDropdown
        maxDate={addYears(TODAY, 1)}
        onChange={(date) => {
          if (isValid(date)) {
            setStartDate(date);
          }
        }}
        name="start_date"
        placeholderText="Select start date"
        selected={startDate}
      />
      <div className="mb lato-bold mt">
        End date (leave empty for current position):
      </div>
      <DatePicker
        className="form-control"
        isClearable={true}
        dateFormat="do MMMM yyyy"
        showYearDropdown
        maxDate={addYears(TODAY, 10)}
        onChange={(date) => {
          setEndDate(date);
        }}
        name="end_date"
        placeholderText="Select end date"
        selected={endDate}
      />
      <div className="mb lato-bold mt">Description (optional):</div>
      <Textarea
        className="form-control mb"
        style={{ height: '100%', resize: 'none' }}
        placeholder="Add details about your role, responsibilities, and achievements."
        onChange={(event) => setDescription(event.target.value)}
        name="description"
        value={description}
        minRows={1}
        maxRows={30}
        maxLength="3000"
      />
      {!isLast && <hr />}
      {isLast && (
        <Button
          bsStyle={'primary'}
          style={{
            alignSelf: 'center',
            width: '40%',
            maxWidth: '100%',
            marginTop: '10',
          }}
          disabled={noTitle || noWorkplace}
          onClick={() => addNewWorkExperience({})}
        >
          <strong>+ Add Work Experience</strong>
        </Button>
      )}
    </div>
  );
};

WorkExperienceForm.propTypes = {
  index: PropTypes.number,
  currentWorkExperience: PropTypes.object,
  updateWorkExperience: PropTypes.func,
  isLast: PropTypes.bool,
  addNewWorkExperience: PropTypes.func,
};

export default WorkExperienceForm;
